const android_osv_list = [
  { value: '3', label: '不限' },
  { value: '4', label: 'Android 4.0 及以上' },
  { value: '5', label: 'Android 5.0 及以上' },
  { value: '6', label: 'Android 6.0 及以上' },
  { value: '7', label: 'Android 7.0 及以上' },
  { value: '8', label: 'Android 8.0 及以上' },
  { value: '9', label: 'Android 9.0 及以上' },
  { value: '10', label: 'Android 10.0 及以上' },
];

const ios_osv_list = [
  {value: '6', label: '不限'},
  {value: '7', label: 'IOS 7.0 及以上'},
  {value: '8', label: 'IOS 8.0 及以上'},
  {value: '9', label: 'IOS 9.0 及以上'},
  {value: '10', label: 'IOS 10.0 及以上'},
  {value: '11', label: 'IOS 11.0 及以上'},
  {value: '12', label: 'IOS 12.0 及以上'},
  {value: '13', label: 'IOS 13.0 及以上'},
]

export default {
  android_osv_list,
  ios_osv_list
}